// auth-signalr.service.ts
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Router } from '@angular/router';
import { Environment } from '../../environments/environment';

 
@Injectable({
  providedIn: 'root'
})
export class AuthSignalRService {
  private hubConnection!: signalR.HubConnection;
 
  constructor(private router: Router) {}
 
  public startConnection(): void {
 
    this.hubConnection = new signalR.HubConnectionBuilder().withUrl(`${Environment.apiUrl}/authhub`, {
        accessTokenFactory: () => ''
      })
      .withAutomaticReconnect()
      .build();
 
    this.hubConnection
      .start()
      .then(() => console.log('SignalR connection started'))
      .catch(err => console.error('SignalR error:', err));
 
    this.hubConnection.on('forceLogout', () => {
      console.warn('Logging out due to server command');
      localStorage.clear()
      window.location.href = Environment.phpConfig.auth.logoutUri

    });
  }
}